import { render, staticRenderFns } from "./DashboardLayoutUser.vue?vue&type=template&id=65232f58"
import script from "./DashboardLayoutUser.vue?vue&type=script&lang=js"
export * from "./DashboardLayoutUser.vue?vue&type=script&lang=js"
import style0 from "./DashboardLayoutUser.vue?vue&type=style&index=0&id=65232f58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports